import React from 'react'
import Svg from '../../../components/Svg/Svg'
import { SvgProps } from '../../../components/Svg/types'

const Icon: React.FC<SvgProps> = (props) => {
  return (
    <Svg viewBox="0 0 19 19" {...props}>
      <path d="M9.875 0.123535C7.66406 0.123535 5.875 1.9126 5.875 4.12354C5.875 6.33447 7.66406 8.12354 9.875 8.12354C12.0859 8.12354 13.875 6.33447 13.875 4.12354C13.875 1.9126 12.0859 0.123535 9.875 0.123535ZM9.875 11.1235C6.87109 11.1235 0.875 12.6313 0.875 15.6235V17.1235C0.875 17.6743 1.32422 18.1235 1.875 18.1235H17.875C18.4258 18.1235 18.875 17.6743 18.875 17.1235V15.6235C18.875 12.6313 12.8789 11.1235 9.875 11.1235Z" />
    </Svg>
  )
}

export default Icon
